/*
 * SonarQube
 * Copyright (C) 2009-2023 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';
import { useCurrentLoginUser } from '../../app/components/current-user/CurrentUserContext';
import A11ySkipTarget from '../../components/a11y/A11ySkipTarget';
import Suggestions from '../../components/embed-docs-modal/Suggestions';
import { translate, translateWithParameters } from '../../helpers/l10n';
import './account.css';
import Nav from './components/Nav';
import UserCard from './components/UserCard';

export default function Account() {
  const currentUser = useCurrentLoginUser();

  const title = translate('my_account.page');
  return (
    <div id="account-page">
      <Suggestions suggestions="account" />
      <Helmet
        defaultTitle={title}
        defer={false}
        titleTemplate={translateWithParameters(
          'page_title.template.with_category',
          translate('my_account.page')
        )}
      />
      <A11ySkipTarget anchor="account_main" />
      <header className="account-header">
        <div className="account-container clearfix">
          <UserCard user={currentUser} />
          <Nav />
        </div>
      </header>

      <main>
        <Outlet />
      </main>
    </div>
  );
}
